import React from 'react';
import { motion } from 'framer-motion';
import {
    FaUnity, FaTools, FaMicrochip, FaVrCardboard, FaBrain,
    FaPython, FaPalette, FaCodeBranch, FaGlobe, FaVideo
} from 'react-icons/fa';

const Services = () => {
    const services = [
        {
            icon: <FaUnity />,
            title: 'Game & Simulation Development',
            description:
                'Experience in Unity, Unreal Engine, Construct 3, and simulator hardware like 720 Flight Simulator chairs and Kinect for immersive AR/VR experiences.',
        },
        {
            icon: <FaMicrochip />,
            title: 'Embedded Systems & IoT',
            description:
                'Prototyping with Arduino, ESPs, Raspberry Pi, and NVIDIA Jetson for hardware-driven solutions.',
        },
        {
            icon: <FaPython />,
            title: 'AI / ML Development',
            description:
                'Model training, evaluation, and deployment using TensorFlow, YOLO, OpenCV, and deep learning frameworks in Python.',
        },
        {
            icon: <FaVrCardboard />,
            title: 'AR/VR & Eye Tracking',
            description:
                'Projects built for Oculus, FOVE VR (eye tracking), HTC Vive, and Vuforia with real-world simulator integrations.',
        },
        {
            icon: <FaPalette />,
            title: 'Design & Video Production',
            description:
                'UI/UX design with Figma, Adobe XD, graphic design with Photoshop & Illustrator, and editing in Premiere Pro, Blender, and Maya.',
        },
        {
            icon: <FaGlobe />,
            title: 'Web Development',
            description:
                'MERN stack expertise (MongoDB, Express, React, Node.js) for robust, scalable, full-stack applications.',
        },
        {
            icon: <FaTools />,
            title: 'Tools & DevOps',
            description:
                'Version control with Git, Tortoise SVN; collaboration via Microsoft Teams and Visual Studio for streamlined delivery.',
        },
        {
            icon: <FaVideo />,
            title: 'Audio & Multimedia',
            description:
                'Sound design and editing with FL Studio and Audacity, used in games, simulators, and promotional content.',
        },
        {
            icon: <FaCodeBranch />,
            title: 'Scripting & Automation',
            description:
                'Custom tooling, scripting, and automation with Python, Linux utilities, and Microsoft Office integration.',
        },
    ];

    return (
        <section id="services" className="relative min-h-screen bg-forest py-20 px-4">
            <div className="container mx-auto max-w-7xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-accent-green mb-6">
                        Our Services
                    </h2>
                    <p className="text-cream text-lg md:text-xl max-w-3xl mx-auto">
                        From immersive simulations and embedded systems to AI-powered apps, full-stack web platforms, and creative media production�we do it all.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <motion.div
                            key={service.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="bg-[#0A2F1D] p-8 rounded-lg border border-accent-green/20 
                         hover:border-accent-green/50 transition-all group"
                        >
                            <div className="text-4xl text-accent-green mb-6 group-hover:scale-110 transform transition-transform">
                                {service.icon}
                            </div>
                            <h3 className="text-xl md:text-2xl font-semibold text-cream mb-4">
                                {service.title}
                            </h3>
                            <p className="text-cream text-base md:text-lg">
                                {service.description}
                            </p>
                        </motion.div>
                    ))}
                </div>

                {/* Background Particles */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-accent-green rounded-full animate-pulse" />
                    <div className="absolute top-1/3 right-1/4 w-3 h-3 bg-accent-green rounded-full animate-pulse delay-100" />
                    <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-accent-green rounded-full animate-pulse delay-200" />
                    <div className="absolute top-1/2 right-1/3 w-2 h-2 bg-accent-green rounded-full animate-pulse delay-300" />
                </div>
            </div>
        </section>
    );
};

export default Services;
